import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 题目新增
  questionAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/questionAdd`,
      method: 'post',
      data,
    });
  },
  // 题目更新
  questionUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/questionUpdate`,
      method: 'post',
      data,
    });
  },
  // 题目列表
  questionPageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/questionPageList?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 题目详情
  questionDetail(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/questionDetail`,
      method: 'get',
      params,
    });
  },
  // 题目删除
  questionDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/questionDelete`,
      method: 'post',
      data,
    });
  },
  // 题库中心：按分类/题型/难度/状态/关键词检索
  bankPageList(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/bankPageList?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 批量移动题目到分类
  questionBatchMove(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/batchMove`,
      method: 'post',
      data,
    });
  },
  // 批量删除题目
  questionBatchDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/batchDelete`,
      method: 'post',
      data,
    });
  },
  // 下载题库导入模板（返回七牛云链接）
  questionImportTemplate(params) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/question_info/questionImportTemplate`,
      method: 'get',
      params,
    });
  },
};
